// @tennis-matches/services/governance — Inline-Bearbeitung Vereinsliste

import { normalizeDiscoverWebsiteUrl } from "./superadmin-club-discover.parse.js";

export const SUPERADMIN_CLUB_LIST_INLINE_EDIT_STORAGE_KEY = "tm_superadmin_clubs_list_inline_edit_v1";

/** @type {Record<string, { type: string, profileKey: string }>} */
export const SUPERADMIN_CLUB_LIST_INLINE_EDITABLE = Object.freeze({
  clubName: { type: "text", profileKey: "club_name" },
  shortName: { type: "text", profileKey: "club_short_name" },
  legalName: { type: "text", profileKey: "legal_name" },
  city: { type: "text", profileKey: "city" },
  postalCode: { type: "text", profileKey: "postal_code" },
  street: { type: "text", profileKey: "street" },
  houseNumber: { type: "text", profileKey: "house_number" },
  country: { type: "text", profileKey: "country" },
  email: { type: "email", profileKey: "email" },
  phone: { type: "tel", profileKey: "phone" },
  websiteUrl: { type: "url", profileKey: "website_url" },
  foundedYear: { type: "text", profileKey: "founded_year" },
  registerCourt: { type: "text", profileKey: "register_court" },
  registerNumber: { type: "text", profileKey: "register_number" },
  dtbClubId: { type: "text", profileKey: "dtb_club_id" },
  btvClubId: { type: "text", profileKey: "btv_club_id" },
});

const CLUB_PROP_BY_COLUMN = {
  clubName: "clubName",
  shortName: "shortName",
  legalName: "legalName",
  city: "city",
  postalCode: "postalCode",
  street: "street",
  houseNumber: "houseNumber",
  country: "country",
  email: "email",
  phone: "phone",
  websiteUrl: "websiteUrl",
  foundedYear: "foundedYear",
  registerCourt: "registerCourt",
  registerNumber: "registerNumber",
  dtbClubId: "dtbClubId",
  btvClubId: "btvClubId",
};

function __asStr(v) {
  return String(v ?? "").trim();
}

function canUseStorage() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function loadSuperadminClubListInlineEditEnabled() {
  if (!canUseStorage()) return false;
  try {
    const raw = window.localStorage.getItem(SUPERADMIN_CLUB_LIST_INLINE_EDIT_STORAGE_KEY);
    if (raw == null) return false;
    return Boolean(JSON.parse(raw)?.enabled);
  } catch {
    return false;
  }
}

export function saveSuperadminClubListInlineEditEnabled(enabled) {
  if (!canUseStorage()) return;
  try {
    window.localStorage.setItem(
      SUPERADMIN_CLUB_LIST_INLINE_EDIT_STORAGE_KEY,
      JSON.stringify({ enabled: Boolean(enabled) })
    );
  } catch {
    // noop
  }
}

export function isSuperadminClubListColumnInlineEditable(columnId) {
  return Boolean(SUPERADMIN_CLUB_LIST_INLINE_EDITABLE[columnId]);
}

export function getSuperadminClubListInlineEditValue(columnId, club) {
  const prop = CLUB_PROP_BY_COLUMN[columnId];
  const c = club && typeof club === "object" ? club : {};
  if (!prop) return "";
  if (columnId === "country") return __asStr(c.country) || "DE";
  if (columnId === "foundedYear") return c.foundedYear != null ? String(c.foundedYear) : "";
  return __asStr(c[prop]);
}

export function buildSuperadminClubListInlineUpdatePayload(columnId, rawValue) {
  const cfg = SUPERADMIN_CLUB_LIST_INLINE_EDITABLE[columnId];
  if (!cfg?.profileKey) return {};
  let value = __asStr(rawValue);
  if (columnId === "foundedYear" && value && !/^[0-9]{4}$/.test(value)) {
    throw new Error("invalid-founded-year");
  }
  if (columnId === "country" && !value) value = "DE";
  if (columnId === "websiteUrl" && value) value = normalizeDiscoverWebsiteUrl(value);
  return { [cfg.profileKey]: value };
}

export function superadminClubListInlineCellKey(tenantId, columnId) {
  return `${__asStr(tenantId)}:${__asStr(columnId)}`;
}
